import React from 'react';
import {
  Platform,
  StyleProp,
  StyleSheet,
  Text as NativeText,
  TextProps as NativeTextProps,
  TextStyle
} from 'react-native';

import { useColor } from '@/hooks/useColor';

import { getStyles } from '../utils/styles';

export interface TextProps {
  style?: StyleProp<TextStyle>;
  fontWeight?: '450' | '500' | '600' | '700' | '900';
  fontStyle?: 'regular';
  font?: 'primary';
}

const textStyles = StyleSheet.create({
  text: {
    letterSpacing: 0,
    fontStyle: 'normal'
  },

  textMedium: {
    fontWeight: '500'
  },

  textMediumBold: {
    fontWeight: '600'
  },

  textBold: {
    fontWeight: '700'
  },

  textBlack: {
    fontWeight: '900'
  }
});

const fontsMap = {
  primary: {
    regular: {
      '450': 'CircularStd-Book',
      '500': 'CircularStd-Medium',
      '600': 'CircularStd-Medium',
      '700': 'CircularStd-Bold',
      '900': 'CircularStd-Black'
    }
  }
};

const Text: React.FC<TextProps & NativeTextProps> = (props) => {
  const colors = useColor();
  const font = props.font || 'primary';
  const fontStyle = props.fontStyle || 'regular';
  const fontWeight = props.fontWeight || '450';
  const lineHeight =
    props.style && 'fontSize' in props.style && props.style?.fontSize
      ? Math.round(props.style.fontSize * 1.3)
      : undefined;

  const styles = getStyles<StyleProp<TextStyle>>([
    [{ ...textStyles.text, color: colors.text }, true],
    [{ fontFamily: fontsMap[font][fontStyle][fontWeight] }, true],
    [props.style, true]
  ]);

  return (
    <NativeText
      {...props}
      allowFontScaling={false}
      style={[styles, { lineHeight: Platform.OS === 'android' ? lineHeight : undefined }]}>
      {props.children}
    </NativeText>
  );
};

export default Text;
